import { Injectable } from '@angular/core';
import { HoverCardState } from './hover-card-state';

/**
 * Egyszerre csak egy megjegyzés-kártya látszik: ha a host gyorsan végigviszi az egeret a sorokon,
 * az új kártya megnyitása azonnal bezárja az előzőt, nem várja ki annak türelmi idejét.
 */
@Injectable({ providedIn: 'root' })
export class HoverCardCoordinator {
  private active?: HoverCardState;

  activate(card: HoverCardState): void {
    if (this.active !== card) {
      this.active?.reset();
    }
    this.active = card;
  }

  release(card: HoverCardState): void {
    if (this.active === card) {
      this.active = undefined;
    }
  }
}
